import { translateCategoryPath } from './categories';

export default function getCategoryParameters(category) {
  return {
    categoryPath: category ? translateCategoryPath(category.path) : 'news',
  };
}
